import React from 'react';
import { useState } from 'react';
import './Research.css';

const Research = () => {

    const [currentSlide, setCurrentSlide] = useState(0);
    const [lightboxVisible, setLightboxVisible] = useState(false);
    const [currentImage, setCurrentImage] = useState('');
    const [lightboxCaption, setLightboxCaption] = useState('');

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev === 4 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? 4 : prev - 1));
    };

    const openLightbox = (imageSrc, caption = '') => {
        setCurrentImage(imageSrc);
        setLightboxCaption(caption);
        setLightboxVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
        setLightboxVisible(false);
        document.body.style.overflow = 'unset';
    };

    const researchStats = [
        { number: "34+", label: "Research Papers Published" },
        { number: "3", label: "Patents Filed" },
        { number: "2", label: "Books Authored" },
        { number: "15+", label: "Conference Presentations" }
    ];

    const patents = [
        {
            title: "Smart Computing Device for Agricultural Recommendations",
            country: "UK Patent",
            number: "Design: 6413862",
            year: "2024"
        },
        {
            title: "Data Processing Equipment for Fashion Products",
            country: "UK Patent",
            number: "Design: 6346358",
            year: "2024"
        },
        {
            title: "Smart Product Display with Customer Interaction Tracking",
            country: "Indian Patent",
            number: "Design: 435862-001",
            year: "2024"
        }
    ];

    const featuredPublications = [
        {
            title: "The COVID-19 Impact on Economy: Expansion or Downturn",
            journal: "Asian and Pacific Economic Review",
            category: "ABDC C-Rated Journal",
            year: "2023"
        },
        {
            title: "Long-term Effects of CSR Activities on Organizational Financial Performance",
            journal: "Korea Review of International Studies",
            category: "ABDC C-Rated Journal",
            year: "2023"
        },
        {
            title: "Blockchain Applications in Managing Oral Oncology Patient Data",
            journal: "Oral Oncology Reports",
            category: "Scopus Indexed",
            year: "2024"
        }
    ];

    const conferences = [
        {
            title: "Marketing Analytics - Comparative Study of Practices and Techniques",
            venue: "Indian Institute of Technology, Bombay",
            year: "2024"
        },
        {
            title: "Sustainable Impact of CSR Activities on Organization's Financial Performance",
            venue: "Indian Institute of Management, Shillong",
            year: "2018"
        },
        {
            title: "Asia Pacific Conference on Education Research, Social Sciences and Humanities",
            venue: "APCERSSH-25 Bangkok",
            year: "2025"
        },
        // International conference on applied Sciences, Engineering,Technology and Management ( ICASETM 2025) at Jakarta  
        {
            title: "International conference on applied Sciences, Engineering,Technology and Management",
            venue: "Jakarta",
            year: "2025"
        }
    ];

    return (
        <section id="research" className="research-section">
            <div className="container">
                <div className="section-header">
                    <h2>Research & Patents</h2>
                    <p>Contributions to academic research and innovation</p>
                </div>

                {/* Research Stats */}
                <div className="research-stats">
                    {researchStats.map((stat, index) => (
                        <div key={index} className="stat-card">
                            <div className="stat-number">{stat.number}</div>
                            <div className="stat-label">{stat.label}</div>
                        </div>
                    ))}
                </div>

                <div className="research-grid">
                    {/* Patents Column */}
                    <div className="research-column">
                        <div className="column-header">
                            <div className="header-icon">💡</div>
                            <h3>Patents & Innovations</h3>
                        </div>
                        <div className="patents-list">
                            {patents.map((patent, index) => (
                                <div key={index} className="patent-item">
                                    <div className="patent-badge">{patent.country}</div>
                                    <h4>{patent.title}</h4>
                                    <div className="patent-details">
                                        <span>{patent.number}</span>
                                        <span className="year">{patent.year}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Publications Column */}
                    <div className="research-column">
                        <div className="column-header">
                            <div className="header-icon">📚</div>
                            <h3>Featured Publications</h3>
                        </div>
                        <div className="publications-list">
                            {featuredPublications.map((pub, index) => (
                                <div key={index} className="publication-item">
                                    <div className="pub-category">{pub.category}</div>
                                    <h4>{pub.title}</h4>
                                    <p className="journal">{pub.journal}</p>
                                    <div className="pub-year">{pub.year}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Conferences Column */}
                    <div className="research-column">
                        <div className="column-header">
                            <div className="header-icon">🎤</div>
                            <h3>Conference Presentations</h3>
                        </div>
                        <div className="conferences-list">
                            {conferences.map((conf, index) => (
                                <div key={index} className="conference-item">
                                    <div className="conf-year">{conf.year}</div>
                                    <h4>{conf.title}</h4>
                                    <p className="venue">{conf.venue}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Awards Section */}
                <div className="awards-section" id='awards'>
                    <div className="section-header">
                        <h3>Research Awards & Recognition</h3>
                    </div>

                    <div className="awards-slider-container">
                        <button className="slider-arrow slider-arrow-left" onClick={prevSlide}>
                            ‹
                        </button>

                        <div className="awards-slider">
                            <div className="awards-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                                {/* slide1 */}
                                <div className="award-slide">
                                    <div className="award-card">
                                        <div className="award-image">
                                            <img
                                                src="../assets/awards/award1.png"
                                                alt="I20R International Woman In Research Award 2025"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextElementSibling.style.display = 'flex';
                                                }}
                                            />
                                            <div className="award-icon-fallback">🏆</div>
                                        </div>
                                        <div className="award-content">
                                            <h4>I20R International Woman In Research Award 2025</h4>
                                            <p>I20R</p>
                                            <button className="view-certificate" onClick={() => openLightbox('../assets/awards/award1.png', 'I20R International Woman In Research Award 2025')}>
                                                View Certificate
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/* slide2 */}
                                <div className="award-slide">
                                    <div className="award-card">
                                        <div className="award-image">
                                            <img
                                                src="../assets/awards/award2.jpg"
                                                alt="Indian Quality Assurance Council"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextElementSibling.style.display = 'flex';
                                                }}
                                            />
                                            <div className="award-icon-fallback">🌟</div>
                                        </div>
                                        <div className="award-content">
                                            <h4>Indian Quality Assurance Council</h4>
                                            <p>Rajkot</p>
                                            <button className="view-certificate" onClick={() => openLightbox('../assets/awards/award2.jpg', 'Indian Quality Assurance Council')}>
                                                View Certificate
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/* slide3 */}
                                <div className="award-slide">
                                    <div className="award-card">
                                        <div className="award-image">
                                            <img
                                                src="../assets/awards/award3.jpg"
                                                alt="Best Education Achiever 2019"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextElementSibling.style.display = 'flex';
                                                }}
                                            />
                                            <div className="award-icon-fallback">📊</div>
                                        </div>
                                        <div className="award-content">
                                            <h4>Best Education Achiever 2019</h4>
                                            <p>New Delhi</p>
                                            <button className="view-certificate" onClick={() => openLightbox('../assets/awards/award3.jpg', 'Best Education Achiever 2019')}>
                                                View Certificate
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/* slide4 */}
                                <div className="award-slide">
                                    <div className="award-card">
                                        <div className="award-image">
                                            <img
                                                src="../assets/awards/award5.jpg"
                                                alt="Reviewer of INSC International Publishing Platforms"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextElementSibling.style.display = 'flex';
                                                }}
                                            />
                                            <div className="award-icon-fallback">📊</div>
                                        </div>
                                        <div className="award-content">
                                            <h4>Reviewer of INSC International Publishing Platforms</h4>
                                            <p>ATSS,s IICMR</p>
                                            <button className="view-certificate" onClick={() => openLightbox('../assets/awards/award5.jpg', 'Reviewer of INSC International Publishing Platforms')}>
                                                View Certificate
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* slide5 */}
                                <div className="award-slide">
                                    <div className="award-card">
                                        <div className="award-image">
                                            <img
                                                src="../assets/awards/award4.jpg"
                                                alt="Young Researcher Award 2023"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextElementSibling.style.display = 'flex';
                                                }}
                                            />
                                            <div className="award-icon-fallback">🎓</div>
                                        </div>
                                        <div className="award-content">
                                            <h4>Young Researcher Award 2023</h4>
                                            <p>ATSS,s IICMR</p>
                                            <button className="view-certificate" onClick={() => openLightbox('../assets/awards/award4.jpg', 'Young Researcher Award 2023')}>
                                                View Certificate
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="slider-arrow slider-arrow-right" onClick={nextSlide}>
                            ›
                        </button>
                    </div>

                    {/* Slider Dots Indicator */}
                    <div className="slider-dots">
                        {[0, 1, 2, 3, 4].map((dot) => (
                            <button
                                key={dot}
                                className={`slider-dot ${currentSlide === dot ? 'active' : ''}`}
                                onClick={() => setCurrentSlide(dot)}
                            />
                        ))}
                    </div>

                    {/* Lightbox Modal */}
                    {lightboxVisible && (
                        <div className="lightbox-overlay" onClick={closeLightbox}>
                            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                                <button className="lightbox-close" onClick={closeLightbox}>×</button>
                                <img src={currentImage} alt="Award Certificate" />
                                <div className="lightbox-caption">{lightboxCaption}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Research;